import React, { type ReactNode, createContext } from "react";

// hooks
import {
  type ThemeColor,
  type SettingsContextProps,
  type Color,
} from "../@types/settings";
import useLocalStorage from "../hooks/useLocalStorage";
// theme
import palette from "../theme/palette";
// @type

// ----------------------------------------------------------------------

const PRIMARY_COLOR = [
  // DEFAULT
  {
    name: "light",
    ...palette.light.primary,
  },
  {
    name: "dark",
    ...palette.dark.primary,
  },
];

function SetColor(themeColor: ThemeColor): Color {
  let color;
  const LIGHT = PRIMARY_COLOR[0];
  const DARK = PRIMARY_COLOR[1];

  switch (themeColor) {
    case "dark":
      color = DARK;
      break;
    default:
      color = LIGHT;
  }
  return color;
}

const initialState: SettingsContextProps = {
  themeMode: "light",
  themeDirection: "ltr",
  themeColor: "light",
  setColor: PRIMARY_COLOR[1],
  colorOption: [],
};

const SettingsContext = createContext(initialState);

interface SettingsProviderProps {
  children: ReactNode;
}

function SettingsProvider({ children }: SettingsProviderProps): JSX.Element {
  const [settings, setSettings] = useLocalStorage("settings", {
    themeMode: "light",
    themeDirection: "ltr",
    themeColor: "light",
    view: null,
  });

  const onChangeMode = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setSettings({
      ...settings,
      themeMode: event.target.value,
    });
  };

  const onChangeDirection = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setSettings({
      ...settings,
      themeDirection: event.target.value,
    });
  };

  const onChangeColor = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setSettings({
      ...settings,
      themeColor: event.target.value,
    });
  };

  const onChangeView = (view: string): void => {
    setSettings({
      ...settings,
      view,
    });
  };

  return (
    <SettingsContext.Provider
      value={{
        ...settings,
        // Mode
        onChangeMode,
        // Direction
        onChangeDirection,
        // Color
        onChangeColor,
        onChangeView,
        setColor: SetColor(settings.themeColor),
        colorOption: PRIMARY_COLOR.map((color) => ({
          name: color.name,
          value: color.main,
        })),
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}

export { SettingsProvider, SettingsContext };
